import React from 'react'

import {
   FollowLinkedinIcon,
   FollowTwitterIcon,
   FollowWhatsappIcon,
   FollowYoutubeIcon
} from '@flowwai-frontend/design-system/icons'

import {
   ClientConfigType,
   ClientSocialMediaLink,
   ClientWebAppMobileConfigType
} from './types'

const config: ClientConfigType = {
   rightRegistered: 'Developed by Deepwork Technologies Pvt. Ltd',
   login: {
      logoURL: '/assets/images/app_logo_image.svg',
      logoWidth: 255
   },
   navbar: {
      logoURL: '/assets/images/app_logo_image.svg'
   },
   enableSupportRequest: false,
   loginLayout: {
      type: 'DEFAULT',
      footerImageUrl: '/assets/images/login_page_pattern_v2.png',
      footerHeight: 78
   },
   privacyPolicyAndTC: {
      privacyPolicyUrl: 'https://buildnow.telangana.gov.in/privacy-policy',
      termsAndConditionsUrl:
         'https://buildnow.telangana.gov.in/terms-and-conditions'
   }
}

export default config

const socialMediasDetailsList: Array<ClientSocialMediaLink> = [
   {
      id: 'TWITTER',
      navigationUrl: 'https://twitter.com/letsflowwai',
      renderIcon: (): React.ReactElement => <FollowTwitterIcon />
   },
   {
      id: 'LINKEDIN',
      navigationUrl: 'https://www.linkedin.com/company/flowwai',
      renderIcon: (): React.ReactElement => <FollowLinkedinIcon />
   },
   {
      id: 'YOUTUBE',
      navigationUrl: 'https://www.youtube.com/@letsflowwai',
      renderIcon: (): React.ReactElement => <FollowYoutubeIcon />
   },
   {
      id: 'WHATSAPP',
      navigationUrl:
         'https://api.whatsapp.com/send/?phone=918584067786&text&type=phone_number&app_absent=0',
      renderIcon: (): React.ReactElement => <FollowWhatsappIcon />
   }
]

export const flowwWebAppMobileScreenConfig: ClientWebAppMobileConfigType = {
   appLogo: '/assets/images/app_logo_image.svg',
   appPreviewImageUrl: '/images/web-page-mobile-view.png',
   bgImageUrl: '/icons/mobile-view-supported-bg-image.svg',
   mobileAppConfig: {
      googleAppLink:
         'https://play.google.com/store/apps/details?id=ai.floww.crm&pli=1',
      mobileAppDescriptionText:
         'To experience Floww.ai on mobile, please download it here'
   },
   socialMediaLinks: socialMediasDetailsList
}
